import React, { useState, useEffect } from "react";
import { fetchState, fetchCity, order_place } from "../api/apiService";
import { useCartContext } from "../context/CartContext";
import { BASE_URL } from '../constants';
import { toast } from "react-hot-toast";
// import "./Checkout.css";

const Checkout = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const [createAccount, setCreateAccount] = useState(false);
  const [shipDifferent, setShipDifferent] = useState(false);
  const { cart, deleteItemFromCart } = useCartContext();
  const [paymentMethod, setPaymentMethod] = useState("cod");

  // =========================
  // LOGIN SESSION STATES
  // =========================
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  // =========================
  // FORM STATES
  // =========================
  const [formData, setFormData] = useState({
    country: "",
    firstName: "",
    lastName: "",
    address: "",
    state: "",
    city: "",
    zip: "",
    email: "",
    houseNo: "",
    landmark: "",
    phone: "",
    password: "",
    shippingAddress: "",
    orderNotes: "",
  });

  // =========================
  // DROPDOWN STATES
  // =========================
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // =========================
  // VALIDATION ERRORS
  // =========================
  const [errors, setErrors] = useState({});

  // =========================
  // CHECK CUSTOMER SESSIONpm
  // =========================
  useEffect(() => {
    const customer = sessionStorage.getItem("customer");

    // if logged in
    if (customer) {

      setIsLoggedIn(true);
      setShowLogin(false);
    } else {

      setIsLoggedIn(false);
      setShowLogin(true);
    }

    setLoading(false);
  }, []);

  // =========================
  // HANDLE INPUT CHANGE
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // clear error while typing
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // =========================
  // FETCH STATES
  // =========================
  useEffect(() => {
    const getStates = async () => {
      try {
        if (formData.country) {
          const response = await fetchState(formData.country);
          setStates(response?.states || response);
          // reset state & city
          setFormData((prev) => ({
            ...prev,
            state: "",
            city: "",
          }));

          setCities([]);
        }
      } catch (error) {
        console.log("State Fetch Error:", error);
      }
    };

    getStates();
  }, [formData.country]);

  // =========================
  // FETCH CITIES
  // =========================
  useEffect(() => {
    const getCities = async () => {
      try {
        if (formData.state) {
          const response = await fetchCity(formData.state);

          setCities(response?.cities || response);

          // reset city
          setFormData((prev) => ({
            ...prev,
            city: "",
          }));
        }
      } catch (error) {
        toast.error(error);
      }
    };

    getCities();
  }, [formData.state]);

  // =========================
  // FORM VALIDATION
  // =========================
  const validateForm = () => {
    let newErrors = {};


    if (!formData.country) {
      newErrors.country = "Country is required";
      //toast.error( "Your order has been placed successfully!");
    }

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }

    if (!formData.state) {
      newErrors.state = "State is required";
    }

    if (!formData.city) {
      newErrors.city = "City is required";
    }

    if (!formData.zip.trim()) {
      newErrors.zip = "Zip code is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    if (!formData.houseNo.trim()) {
      newErrors.houseNo = "House number is required";
    }

    if (!formData.landmark.trim()) {
      newErrors.landmark = "Landmark is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid 10 digit number";
    }

    if (createAccount && !formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    if (
      shipDifferent &&
      !formData.shippingAddress.trim()
    ) {
      newErrors.shippingAddress =
        "Shipping address is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // =========================
  // SUBMIT FORM
  // =========================
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (validateForm()) {

      try {
        if (cart?.cartItems.length > 0) {
          var cart_details = cart?.cartItems;
          const customer = localStorage.getItem("session");
          const response = await order_place({
            ...formData,
            createAccount,
            shipDifferent,
            cart_details,
            customer
          });

          toast.success(response.message);
          localStorage.removeItem("cart");
          localStorage.removeItem("cartItems");

        } else {
          toast.error('Please add the product in cart.');
          return false;

        }

      } catch (err) {

        // console.log(err);

        toast.error(err.message);
      }
    }
  };

  // =========================
  // LOADING
  // =========================
  if (loading) {
    return <h3 className="text-center mt-5">Loading...</h3>;
  }

  return (
    <>
      {/* LOGIN MODAL
      {showLogin && (
        <div className="login-modal">
          <div className="login-modal-content">
            <h3>Please Login</h3>

            <p>
              You must login before checkout.
            </p>

            <button
              className="btn btn-primary"
              onClick={() =>
                (window.location.href = "/login")
              }
            >
              Go To Login
            </button>
          </div>
        </div>
      )} */}

      {/* SHOW CHECKOUT ONLY IF LOGGED IN */}
      {/* {isLoggedIn && ( */}
      <>
        {/* Breadcrumb Area */}
        <div className="breadcrumb-area">
          <div className="container">
            <div className="breadcrumb-content">
              <h2>Checkout</h2>

              <ul>
                <li>
                  <a href="/">Home</a>
                </li>

                <li className="active">
                  Checkout
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Checkout Area */}
        <div className="checkout-area">
          <div className="container">
            <div className="row">
              {/* LEFT SIDE */}
              <div className="col-lg-6 col-12">
                <form onSubmit={handleSubmit}>
                  <div className="checkbox-form">
                    <h3>Address Details</h3>

                    <div className="row">
                      {/* COUNTRY */}
                      <div className="col-md-12">
                        <div className="country-select clearfix">
                          <label>
                            Country{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <select
                            className="nice-select wide"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                          >
                            <option value="">
                              Select country
                            </option>

                            <option value="229">
                              UAE
                            </option>

                            <option value="101">
                              India
                            </option>
                          </select>

                          {errors.country && (
                            <small className="text-danger">
                              {errors.country}
                            </small>
                          )}
                        </div>
                      </div>

                      {/* FIRST NAME */}
                      <div className="col-md-6">
                        <div className="checkout-form-list">
                          <label>
                            First Name{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="text"
                            name="firstName"
                            value={
                              formData.firstName
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.firstName && (
                            <small className="text-danger">
                              {
                                errors.firstName
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* LAST NAME */}
                      <div className="col-md-6">
                        <div className="checkout-form-list">
                          <label>
                            Last Name{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="text"
                            name="lastName"
                            value={
                              formData.lastName
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.lastName && (
                            <small className="text-danger">
                              {
                                errors.lastName
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* ADDRESS */}
                      <div className="col-md-12">
                        <div className="checkout-form-list">
                          <label>
                            Address{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            placeholder="Street address"
                            type="text"
                            name="address"
                            value={
                              formData.address
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.address && (
                            <small className="text-danger">
                              {
                                errors.address
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* STATE */}
                      <div className="col-md-6">
                        <div className="checkout-form-list">
                          <label>
                            State{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <select
                            name="state" className="nice-select wide"
                            value={
                              formData.state
                            }
                            onChange={
                              handleChange
                            }
                          >
                            <option value="">
                              Select State
                            </option>

                            {states?.map(
                              (
                                state,
                                index
                              ) => (
                                <option
                                  key={index}
                                  value={
                                    state.id
                                  }
                                >
                                  {
                                    state.name
                                  }
                                </option>
                              )
                            )}
                          </select>

                          {errors.state && (
                            <small className="text-danger">
                              {errors.state}
                            </small>
                          )}
                        </div>
                      </div>

                      {/* CITY */}
                      <div className="col-md-6">
                        <div className="checkout-form-list">
                          <label>
                            Town / City{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <select
                            name="city" className="nice-select wide"
                            value={
                              formData.city
                            }
                            onChange={
                              handleChange
                            }
                          >
                            <option value="">
                              Select City
                            </option>

                            {cities?.map(
                              (
                                city,
                                index
                              ) => (
                                <option
                                  key={index}
                                  value={
                                    city.id
                                  }
                                >
                                  {
                                    city.name
                                  }
                                </option>
                              )
                            )}
                          </select>

                          {errors.city && (
                            <small className="text-danger">
                              {errors.city}
                            </small>
                          )}
                        </div>
                      </div>

                      {/* ZIP */}
                      <div className="col-md-6 mt-4">
                        <div className="checkout-form-list">
                          <label>
                            Postcode / Zip{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="text"
                            name="zip"
                            value={formData.zip}
                            onChange={
                              handleChange
                            }
                          />

                          {errors.zip && (
                            <small className="text-danger">
                              {errors.zip}
                            </small>
                          )}
                        </div>
                      </div>

                      {/* EMAIL */}
                      <div className="col-md-6 mt-4">
                        <div className="checkout-form-list">
                          <label>
                            Email Address{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="email"
                            name="email"
                            value={
                              formData.email
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.email && (
                            <small className="text-danger">
                              {
                                errors.email
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* HOUSE NO */}
                      <div className="col-md-6">
                        <div className="checkout-form-list">
                          <label>
                            House No{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="text"
                            name="houseNo"
                            value={
                              formData.houseNo
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.houseNo && (
                            <small className="text-danger">
                              {
                                errors.houseNo
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* LANDMARK */}
                      <div className="col-md-6">
                        <div className="checkout-form-list">
                          <label>
                            Landmark{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="text"
                            name="landmark"
                            value={
                              formData.landmark
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.landmark && (
                            <small className="text-danger">
                              {
                                errors.landmark
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* PHONE */}
                      <div className="col-md-12">
                        <div className="checkout-form-list">
                          <label>
                            Phone{" "}
                            <span className="required">
                              *
                            </span>
                          </label>

                          <input
                            type="text"
                            name="phone"
                            value={
                              formData.phone
                            }
                            onChange={
                              handleChange
                            }
                          />

                          {errors.phone && (
                            <small className="text-danger">
                              {
                                errors.phone
                              }
                            </small>
                          )}
                        </div>
                      </div>

                      {/* CREATE ACCOUNT */}
                      <div className="col-md-12">
                        <div className="checkout-form-list create-acc">
                          <input
                            id="cbox"
                            type="checkbox"
                            checked={
                              createAccount
                            }
                            onChange={() =>
                              setCreateAccount(
                                !createAccount
                              )
                            }
                          />

                          <label>
                            Create an account?
                          </label>
                        </div>

                        {createAccount && (
                          <div className="checkout-form-list create-account">
                            <p>
                              Create an account
                              by entering the
                              information below.
                            </p>

                            <label>
                              Account password{" "}
                              <span className="required">
                                *
                              </span>
                            </label>

                            <input
                              placeholder="password"
                              type="password"
                              name="password"
                              value={
                                formData.password
                              }
                              onChange={
                                handleChange
                              }
                            />

                            {errors.password && (
                              <small className="text-danger">
                                {
                                  errors.password
                                }
                              </small>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* SHIPPING */}
                    <div className="different-address">
                      <div className="ship-different-title">
                        <h3>
                          <label>
                            Ship to a different
                            address?
                          </label>

                          <input
                            type="checkbox"
                            checked={
                              shipDifferent
                            }
                            onChange={() =>
                              setShipDifferent(
                                !shipDifferent
                              )
                            }
                          />
                        </h3>
                      </div>

                      {shipDifferent && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="checkout-form-list">
                              <label>
                                Address{" "}
                                <span className="required">
                                  *
                                </span>
                              </label>

                              <input
                                placeholder="Shipping Address"
                                type="text"
                                name="shippingAddress"
                                value={
                                  formData.shippingAddress
                                }
                                onChange={
                                  handleChange
                                }
                              />

                              {errors.shippingAddress && (
                                <small className="text-danger">
                                  {
                                    errors.shippingAddress
                                  }
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* NOTES */}
                      <div className="order-notes">
                        <div className="checkout-form-list checkout-form-list-2">
                          <label>
                            Order Notes
                          </label>

                          <textarea
                            cols="30"
                            rows="10"
                            placeholder="Notes about your order"
                            name="orderNotes"
                            value={
                              formData.orderNotes
                            }
                            onChange={
                              handleChange
                            }
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* PLACE ORDER */}
                  <div className="order-button-payment mt-3">
                    <input
                      value="Place order"
                      type="submit"
                    />
                  </div>
                </form>
              </div>

              {/* RIGHT SIDE */}
              <div className="col-lg-6 col-12">
                <div className="your-order">
                  <h3>Your order</h3>

                  <div className="your-order-table table-responsive">
                    <table className="table border-0">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Total</th>
                        </tr>
                      </thead>

                      <tbody>
                        {cart?.cartItems.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {item.name}{" "}
                              <strong>
                                × {item.quantity}
                              </strong>
                            </td>

                            <td>
                              ₹
                              {item.price * item.quantity}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr>
                          <th>Cart Subtotal</th>

                          <td>
                            ₹
                            {cart?.cartItems.reduce(
                              (total, item) =>
                                total +
                                item.price * item.quantity,
                              0
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Discount</th>

                          <td>

                            ₹
                            {cart?.cartItems.reduce(
                              (total, item) =>
                                total +
                                item.price *
                                item.quantity,
                              0
                            )}

                          </td>
                        </tr>
                        <tr>
                          <th>Order Total</th>

                          <td>
                            <strong>
                              ₹
                              {cart?.cartItems.reduce(
                                (total, item) =>
                                  total +
                                  item.price *
                                  item.quantity,
                                0
                              )}
                            </strong>
                          </td>
                        </tr>

                      </tfoot>
                    </table>
                  </div>

                  {/* PAYMENT */}
                  <div className="payment-method">
                    <div className="payment-row">

                      {/* COD */}
                      <label className="payment-option">
                        <input
                          type="radio"
                          name="payment_method"
                          value="cod"
                          checked={paymentMethod === "cod"}
                          onChange={(e) =>
                            setPaymentMethod(e.target.value)
                          }
                        />
                        <span>Cash On Delivery</span>
                      </label>

                      {/* UPI / CARD */}
                      <label className="payment-option">
                        <input
                          type="radio"
                          name="payment_method"
                          value="online"
                          checked={paymentMethod === "online"}
                          onChange={(e) =>
                            setPaymentMethod(e.target.value)
                          }
                        />
                        <span>UPI / Card Payment</span>
                      </label>

                      {/* REMOVE / EXTRA OPTION */}
                      <button
                        type="button"
                        className="payment-btn remove"
                        onClick={() =>
                          deleteItemFromCart(cart?.cartItems)
                        }
                      >
                        Remove Cart
                      </button>

                    </div>
                  </div>
                </div>
              </div>
              {/* RIGHT SIDE END */}
            </div>
          </div>
        </div>
      </>
      {/* )} */}
    </>
  );
};

export default Checkout;